module.exports = __webpack_public_path__ + "static/media/BusinessSupport.404fac6a.jpeg";